import LeftArrow from "Assets/Icons/LeftArrow";
import SliderPaneComponent from "Components/CommonComponents/SliderPaneComponent";
import Typography from "Components/CommonComponents/Typography";
import { ToastContextDispatch } from "Context/CommonContext";
import MyBatchTestSyllabusFilter from "Pages/MyBatchTestSyllabus/MyBatchTestSyllabusFilter";
import MyBatchTestSyllabusListing from "Pages/MyBatchTestSyllabus/MyBatchTestSyllabusListing";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Spinner } from "reactstrap";
import {
  BASE_URL,
  GET_TESTSYLLABUS,
} from "utilFunctions/Constants/urlConstants";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
export interface testSyllabusDetailIF {
  subject: string;
  courseId: string;
  tableOfContent: any[];
  nodesMarked: string;
}
const MyBatchTestSyllabus = () => {
  const navigate = useNavigate();
  const { screen }: any = useWindowSize();
  const location = useLocation();
  const ToastDispatch = useContext(ToastContextDispatch);
  const [testSyllabusDetail, setTestSyllabusDetail] = useState<
    testSyllabusDetailIF[]
  >([]);
  const [testId, setTestId] = useState<string>("");
  const [testDetail, setTestDetail] = useState<any>("");
  const [testSyllabusStatus, settestSyllabusStatus] = useState<any>("");
  const [selectedCouseSyllabus, setselectedCouseSyllabus] = useState<any>("");
  const [ispaneopen, setIspaneOpen] = useState<boolean>(false);
  const [batchName, setBatchName] = useState<any>("");
  const { makeRequest: GettestSyllabusDetail, loading: loading } = useGetApi(
    (data: any) => {
      if (
        data["data"] &&
        data["data"]["testSyllabus"] &&
        data["data"]["testSyllabus"].length
      ) {
        setTestSyllabusDetail(data["data"]["testSyllabus"] || []);
      } else {
        setTestSyllabusDetail([]);
      }
    },
    (error: any) => {
      setTestSyllabusDetail([]);
      if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["internalCode"] &&
        error["response"]["data"]["internalCode"] != "1008"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );
  const renderingTime = (date: any) => {
    return <div className="d-flex">{moment(date).format("D MMM YY")}</div>;
  };
  const returnBatchData = (
    testSyllabusStatus: any,
    id: number,
    batchId: number
  ) => {
    return testSyllabusStatus
      ?.find((ele: any) => ele.testScheduleId == id && ele.batchId == batchId)
      ?.testSyllabusStatusDataList.map((ele: any) => ({
        subj: ele.subject,
        markedPlLecCount: ele.markedNodeCount,
        totalPlLecCount: ele.totalNodeCount,
      }));
  };
  useEffect(() => {
    const testId =
      location.pathname.split("/")[location.pathname.split("/").length - 1] ||
      "";
    const { state } = location;
    if (state) {
      const { test, batchId, testSyllabusStatus, batchName } = state;
      if (testSyllabusStatus) {
        const batchData = returnBatchData(
          testSyllabusStatus,
          Number(testId),
          batchId
        );
        settestSyllabusStatus(batchData);
        setselectedCouseSyllabus(
          batchData && batchData.length ? batchData[0] : null
        );
      }
      if (test) {
        setTestDetail(test);
      }
      setTestId(testId);
      if (testId) {
        const url =
          BASE_URL +
          GET_TESTSYLLABUS +
          `?batchId=${batchId}&testScheduledId=${testId}`;
        GettestSyllabusDetail(url);
      }
      if (batchName) {
        setBatchName(batchName);
      }
    }
  }, [location]);
  useEffect(() => {
    if (["xxl", "xl", "lg"].includes(screen)) {
      setIspaneOpen(false);
    } else {
      setIspaneOpen(true);
    }
  }, [screen]);
  return (
    <>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <Spinner color="info"></Spinner>
        </div>
      ) : (
        <>
          {["xs", "sm", "md"].includes(screen) ? (
            <SliderPaneComponent
              isPaneOpen={ispaneopen}
              header={
                <div className="d-flex">
                  <LeftArrow
                    className={"cursorHoverCSS mr-1"}
                    onClick={() => {
                      setIspaneOpen(!ispaneopen);
                      navigate(-1);
                    }}
                  />
                  <Typography
                    variant={["xxl", "xl", "lg"].includes(screen) ? "h4" : "h6"}
                    color="black"
                  >
                    {" "}
                    <div className="d-flex gap-2">
                      {testDetail?.type} {"   |   "} {batchName}
                    </div>
                    <div className="testDetailSpan">
                      {"Test Date: "}&nbsp;
                      {testDetail.startDate &&
                        renderingTime(testDetail.startDate)}
                      -{testDetail.endDate && renderingTime(testDetail.endDate)}
                    </div>
                  </Typography>
                </div>
              }
              bodyClassName={"bodyClassName"}
              onRequestClose={() => {
                setIspaneOpen(!ispaneopen);
              }}
            >
              <MyBatchTestSyllabusFilter
                testDetail={testDetail}
                testSyllabusStatus={testSyllabusStatus}
                selectedCourseSyllabus={selectedCouseSyllabus}
                setselectedCouseSyllabus={setselectedCouseSyllabus}
                testId={testId}
                testSyllabusDetail={testSyllabusDetail}
              ></MyBatchTestSyllabusFilter>
              <MyBatchTestSyllabusListing
                testSyllabusDetail={
                  testSyllabusDetail.filter(
                    (ele: any) => ele.subject === selectedCouseSyllabus?.subj
                  )?.[0]
                }
              ></MyBatchTestSyllabusListing>
            </SliderPaneComponent>
          ) : (
            <>
              <MyBatchTestSyllabusFilter
                testDetail={testDetail}
                testSyllabusStatus={testSyllabusStatus}
                selectedCourseSyllabus={selectedCouseSyllabus}
                setselectedCouseSyllabus={setselectedCouseSyllabus}
                testId={testId}
                testSyllabusDetail={testSyllabusDetail}
                batchName={batchName}
              ></MyBatchTestSyllabusFilter>
              <MyBatchTestSyllabusListing
                testSyllabusDetail={
                  testSyllabusDetail.filter(
                    (ele: any) => ele.subject === selectedCouseSyllabus?.subj
                  )?.[0]
                }
              ></MyBatchTestSyllabusListing>
            </>
          )}
        </>
      )}
    </>
  );
};
export default MyBatchTestSyllabus;
